<template>
  <div class="trending-skeleton">
    <div class="card-trending-job-skeleton">
      <div class="card-trending-job-skeleton__content">
        <div class="card-trending-job-skeleton__line card-trending-job-skeleton__line--title card-trending-job-skeleton__line--pulse" />
        <div class="card-trending-job-skeleton__line card-trending-job-skeleton__line--description card-trending-job-skeleton__line--pulse" />
      </div>
    </div>
  </div>
</template>
<style lang='scss' scoped>
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.card-trending-job-skeleton {
  display: flex;
  align-items: center;
  padding: 18px 26px; // Matches your card-trending-job padding
  background: #FFFFFF;
  border: 1px solid #0000001A;
  border-radius: 8px;
  gap: 16px;
  overflow: hidden;

  // Shared Modifier for the Shimmer effect
  &__avatar--pulse,
  &__line--pulse {
    background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
  }

  &__avatar {
    flex-shrink: 0;
    @include vwUnit('width', 48, 42);
    @include vwUnit('height', 48, 42);
    border-radius: 50%;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 6px; // Tight spacing for title and short description
  }

  &__line {
    border-radius: 4px;

    &--title {
      height: 18px;
      width: 60%;
    }

    &--description {
      height: 12px;
      width: 85%;
    }
  }
}
</style>
